import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TexasButtons = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={4}
      sx={{
        flexGrow: 1,
        minHeight: 0,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Button
        sx={{
          width: { xs: '100%', md: 500 },
          height: { xs: 150, md: 300 },
          fontSize: { xs: '16px', md: '30px' },
          backgroundColor: 'var(--tx-secondary)',
          color: '#FFFFFF',
        }}
        variant='contained'
        href={process.env.REACT_APP_TEXAS_PLAYSLIP_FORM_URL}
      >
        {t('buttons.playslips_ticket_stock')}
      </Button>
      <Button
        sx={{
          width: { xs: '100%', md: 500 },
          height: { xs: 150, md: 300 },
          fontSize: { xs: '16px', md: '30px' },
          backgroundColor: 'var(--tx-primary)',
          color: '#000000',
        }}
        variant='contained'
        onClick={() => navigate('scratch-tickets')}
      >
        {t('buttons.scratch_tickets')}
      </Button>
    </Stack>
  );
};

export default TexasButtons;
